import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/events";

export default function Voices() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="用户口碑"
          title="他们说，这样看瓜更省心"
          desc="来自通勤路上、选题桌前和追综艺现场的真实使用反馈。"
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="h-11 w-11 overflow-hidden rounded-full border border-background-300">
                  <img
                    src={item.avatar}
                    alt={`${item.name}的头像`}
                    title={`${item.name} 热搜吃瓜用户口碑`}
                    className="h-full w-full object-cover object-top"
                  />
                </span>
                <span className="flex flex-col">
                  <span className="font-heading text-sm font-semibold text-foreground-950">
                    {item.name}
                  </span>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}